export default {

  setEmpresas({ commit }, payload) {
    commit('setEmpresas', payload)
  }

}
